import script from "./DigitalProductDownloadButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductDownloadButton.vue?vue&type=script&lang=js"
export * from "./DigitalProductDownloadButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductDownloadButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/digital-product-card/DigitalProductDownloadButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f170c70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f170c70', __exports__)) {
    api.reload('3f170c70', __exports__)
  }
  
}


export default __exports__